<template>
  <div class="section-main__warp itemConfiguration">
    <ioc-table
      v-model="plan"
      :data="tableData"
      :option="option"
      :page="page"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <!-- 顶部按钮 自定义 -->
      <template slot="menuLeft">
        <el-button
          type="primary"
          v-auth="'/assetsManage/itemConfig:add'"
          size="small"
          class="iss-operation-button"
          icon="el-icon-plus"
          @click="handleAdd"
        >
          {{ $t("workGroup.button.add") }}
        </el-button>
      </template>
      <!-- 表格按钮 自定义 -->
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="修改"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            v-auth="'/assetsManage/itemConfig:update'"
            icon="iconfont icon-Edit"
            @click="handleEdit(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            v-auth="'/assetsManage/itemConfig:delete'"
            icon="el-icon-delete"
            @click="handleDel(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog
      :title="title"
      v-if="visible"
      :visible.sync="visible"
      width="500px"
      class=""
    >
      <el-form
        ref="dialogForm"
        :model="configForm"
        label-width="110px"
        :rules="rules"
      >
        <el-form-item label="巡检项名称" prop="patrolItemGroupName">
          <el-input v-model="configForm.patrolItemGroupName"></el-input>
        </el-form-item>
        <el-form-item
          label="巡检子项"
          prop="patrolItemNameList"
          class="patrolItem"
        >
          <el-tag
            :key="tag"
            v-for="tag in configForm.patrolItemNameList"
            closable
            :disable-transitions="false"
            @close="handleTagClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            style="width: 100%"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <div
            v-else
            :class="[
              'button-new-tag',
              configForm.patrolItemNameList.length === 0 ? '' : 'tagFlag'
            ]"
            @click="showInput"
          >
            +
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="info" @click="handleClose">{{
            $t("accountGroup.button.cancel")
          }}</el-button>
          <el-button type="primary" @click="handleSave">{{
            $t("accountGroup.button.save")
          }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";
import option from "../const/configOption";
import utils from "@src/common/utils";

export default {
  name: "itemConfiguration",
  data() {
    return {
      inputVisible: false,
      inputValue: "",
      title: "新增",
      configForm: {
        patrolItemGroupName: "",
        patrolItemNameList: [],
        patrolItemGroupCode: ""
      },
      rules: {
        patrolItemGroupName: [
          { required: true, message: "请输入巡检项名称", trigger: "blur" }
        ],
        patrolItemNameList: [
          { required: true, message: "请输入巡检子项", trigger: "blur" }
        ]
      },
      visible: false,
      plan: {
        areaList: ""
      },
      tableData: [],
      checkedAssets: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      option: option()
    };
  },
  mounted() {
    this.getList();
  },
  created() {},
  computed: {},
  methods: {
    handleClose() {
      this.visible = false;
      this.configForm = {
        patrolItemGroupName: "",
        patrolItemNameList: [],
        patrolItemGroupCode: ""
      };
    },
    handleEdit(item) {
      this.visible = true;
      this.title = "修改";
      this.configForm = {
        patrolItemGroupName: item.patrolItemGroupName,
        patrolItemNameList: item.patrolItemNameList,
        patrolItemGroupCode: item.patrolItemGroupCode
      };
    },
    handleSave() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          if (this.title !== "修改") {
            this.$fetch(api.assetsManage.addItemConfig, this.configForm).then(
              (res) => {
                if (res && res.success) {
                  this.handleClose();
                  this.getList();
                  this.$message.success("新增成功");
                } else {
                  this.$message.error(res.msgContent);
                }
              }
            );
          } else {
            this.$fetch(
              api.assetsManage.updatePatrolItemGroupConfigInfo,
              this.configForm
            ).then((res) => {
              if (res && res.success) {
                this.handleClose();
                this.getList();
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.msgContent);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleTagClose(tag) {
      this.configForm.patrolItemNameList.splice(
        this.configForm.patrolItemNameList.indexOf(tag),
        1
      );
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.configForm.patrolItemNameList.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleSearchReset() {
      this.getList();
    },
    getList() {
      const params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      this.$fetch(api.assetsManage.queryAssetsList, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
        } else {
          this.tableData = response.returnObj
            ? Object.freeze([...response.returnObj.list])
            : [];
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        }
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleAdd() {
      this.visible = true;
      this.inputVisible = true;
      this.title = "新增";
      this.configForm = {
        patrolItemGroupName: "",
        patrolItemNameList: [],
        patrolItemGroupCode: ""
      };
    },
    handleDel(row) {
      const params = {
        patrolItemGroupCodeList: [row.patrolItemGroupCode]
      };
      this.$confirm("您确定删除该巡检配置项吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$fetch(api.assetsManage.deleteItemConfig, params).then(
          (response) => {
            if (response && response.success) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(response.msgContent);
            }
          }
        );
      });
    }
  }
};
</script>
<style lang="scss">
.itemConfiguration {
  .patrolItem {
    display: flex;

    .tagFlag {
      margin-bottom: 8px;
    }
    .el-tag {
      height: 32px;
      line-height: 32px;
      border-radius: 1px;
      margin-right: 10px;
      margin-bottom: 8px;
    }

    .el-form-item__content {
      margin-left: 0 !important;
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    .button-new-tag {
      height: 20px;
      cursor: pointer;
      width: 20px;
      // background: #2a5094;
      display: flex;
      align-items: center;
      justify-content: center;
      // color: #0a2248;
      border-radius: 50%;
      font-size: 24px;
    }
    .input-new-tag {
      width: 200px;
      margin-bottom: 8px;
      cursor: pointer;
    }
  }
}
</style>
